module.exports = __webpack_public_path__ + "static/media/challenge.9fa8b77e.png";